
const S200 = {
  header: {
    category: "Fogászati Kezelőegység",
    model: "S200",
    tagline: "A szakmai fejlődés alapja.",
  },

  hero: {
    image: "/uploads/S200.png",
    buttonText: "Digitális bemutatóterem",
    title: "Gazdaságos választás dentálhigiénikusok számára",
    description:
      "Az S200 fogászati ​​szék szett egy alap széksorozat, és ideális választás fogászati ​​vagy dentálhigiéniai praxis indításához. A szett felső vezetővel (CONTINENTAL), alsó vezetővel (INTERNATIONAL) vagy ORTO-val szerelhető fel. A fogászati ​​egység széles választékban kínál opcionális eszközöket. A kezelőpanel alapfelszereltség, az LCD vezérlőkijelző opcionális. Kényelmesen integrálható intraorális röntgen, RVG érzékelő, endodonciai mikromotor és APEX lokátor.",
    showroom: "https://www.vitshowroom.it/interactive/sternweber/index.php?IDmodello=1800&param=sala1,-138.78,-19.20,57.07,4,ENG"
  },

  description: {
    title: "Fogászati ​​székre szerelhető egységek alapfelszerése",
    columns: [
      [
        "Ergonomikus kialakítás a fogászati ​​csapat számára",
        "Innovatív kialakítás a páciensek maximális kényelme érdekében",
        "Orvosi egység széles választékban választható eszközökkel",
      ],
      [
        "Gördülékenyen, dinamukus mozgatás",
        "Lehetőség a fogorvosi szék 4 munkapozíciójának mentésére",
        "Asszisztensi pult akár 5 eszközzel és opcionális karral",
      ],
    ],
    image: "/uploads/S200-pano.jpg",
  },

  sections: [
    {
      title: "Verziók",
      cards: [
        {
          image: "/uploads/S200-cont.png",
          alt: "S200 Continental",
          title: "Continental",
          description: "Az S.P.R.I.D.O. modellhez képest ez a verzió egy kompakt modullal és olyan eszközökkel rendelkezik, amelyek csövei anélkül nyúlnak ki, hogy a csuklót megnyomnák. A fogorvos a modul fogantyúján található gomb megnyomásával kioldhatja az opcionális pneumatikus féket a modul magasságának beállításához.",
        },
        {
          image: "/uploads/S200-inter.png",
          alt: "S200 International",
          title: "International",
          description: "Ennél a változatnál a műszerek függőcsövekkel rendelkeznek, ergonomikus elrendezésben az egyszerű kezelés érdekében. A fecskendő függőlegesen helyezkedik el a kézidarab-tartó elején, így biztosítva a jó fogást. Ez a modell tökéletes azoknak a szakembereknek, akik szeretnek 12 órás pozícióban dolgozni.",
        },
        {
          image: "/uploads/S200-ortho.png",
          alt: "S200 Ortho",
          title: "Ortho",
          description: "Ez a verzió kifejezetten azoknak a fogszabályozó szakorvosoknak készült, akiknek rendezett kezelőfelületre van szükségük. Az asszisztensi oldalon konzollal és kijelzővel ellátott műszermodul mellett egy pantográf karon elhelyezett nagyméretű tálcatartóval, valamint egy 22 hüvelykes LED-monitor beépítési lehetőségével is rendelkezik.",
        }
      ],
    },

    {
      title: "Konzol",
      cards: [
        {
          image: "/uploads/S200-digit.png",
          alt: "S200 Digit Console",
          title: "Digit Konzol",
          description:
            "Ez az érintőképernyős konzol alapfelszereltségként beépített röntgennézővel és alfanumerikus kijelzővel rendelkezik, amely az adatokat és a működési paramétereket jeleníti meg.",
        },
        {
          image: "/uploads/S200-lcd.png",
          alt: "S200 LCD Console",
          title: "LCD Konzol",
          description:
            "Ez az opcionális érintőképernyős konzol lehetővé teszi a többkezelős kezelést és az integrált eszközök fejlett vezérlését. Emellett az elektronikus apexlokátor állapotát is megjeleníti.",
        }
      ],
    },

    {
      title: "Konzervatív Fogászat",
      cards: [
        {
          image: "/uploads/S200-mikromotor.png",
          alt: "S200 Digit Console",
          title: "FLUO mikromotorok",
          description:
            "Könnyűek és még a korábbiaknál is halkabbak, a Stern Weber mikromotorok FIT (fluoreszcencia-alapú azonosítási technika) technológiával kaphatók, hogy könnyebben felismerjék a fogakban lévő kompozit anyagokat, ezáltal felgyorsítva az eltávolítást.",
        },
        {
          image: "/uploads/S200-tled.png",
          alt: "S200 LCD Console",
          title: "T-LED light",
          description:
            "A T-LED polimerizációs lámpa emissziós spektrumával rendelkezik, amely még a legújabb generációs kompozitok aktiválásához is alkalmas. Forgatható markolattal, felhasználóbarát kezelőfelülettel és a konzolprogrammal – a 7 elérhető program egyikével – rendelkezik, amely 5 rövid, gyorsan egymást követő emissziót kínál.",
        }
      ],
    },

    {
      title: "Páciens szék",
      cards: [
        {
          image: "/uploads/S200-standard.png",
          alt: "S200 Digit Console",
          title: "Normál háttámla",
          description:
            "Ez a háttámla úgy van kialakítva, hogy a fogászati ​​személyzet könnyen közelebb tudjon lépni a pácienshez a kezelés során. Felnőttek, gyermekek és mindenféle kezeléshez alkalmas.",
        },
        {
          image: "/uploads/S200-nordic.png",
          alt: "S200 LCD Console",
          title: "Nordic háttámla",
          description:
            "Ez a háttámla nagyobb kényelmet biztosít a hosszú kezelések során, és úgy lett kialakítva, hogy segítse a „közvetett látásmódban” dolgozó fogorvosokat.",
        },
        {
          image: "/uploads/S200-atlaxis.png",
          alt: "S200 LCD Console",
          title: "Atlaxis háttámla",
          description:
            "A fejtámla hűen követi a páciens anatómiáját. A pneumatikus zár rendkívül egyszerű, ujjbeggyel történő kioldásával lehetővé válik a szemüreg mozgása a tökéletes pozicionálás érdekében, beleértve a függőleges beállítást is.",
        },
        {
          image: "/uploads/S200-sensor.png",
          alt: "S200 LCD Console",
          title: "Opcionális páciensérzékelő",
          description:
            "Opcionális páciensérzékelő. Ez az opcionális érzékelő a háttámla és az ülés között található. Statisztikai célokra érzékeli a páciens jelenlétét, amelyet a Di.V.A. virtuális asszisztens feldolgoz; emellett számos intelligens automatizmus használatával javítja a berendezések fenntarthatóságát.",
        },
        {
          image: "/uploads/S200-memory.png",
          alt: "S200 LCD Console",
          title: "Memória hab",
          description:
            "A speciális kárpitozási megoldások (opcionális) kivételes kényelmet és hatékony anatómiai támasztást garantálnak.",
        },
        {
          image: "/uploads/S200-install.png",
          alt: "S200 LCD Console",
          title: "Sokoldalú telepítés",
          description:
            "A szék a meglévő padlóaljzatokhoz való csatlakoztatáshoz tervezett csatlakozóval rendelkezik, amely közvetlenül a lábtartó alatt vagy a készülékház eleje alatt található.",
        }
      ],
    },
    {
      title: "Higénia",
      cards: [
        {
          image: "/uploads/S200-higenia.png",
          alt: "S200 Digit Console",
          title: "Tervezett higiénia",
          description:
            "A fogászati ​​egységek tervezése során arra összpontosítanak, hogy az orvosok a lehető legegyszerűbben elvégezhessék a szükséges feladatokat. Egyrészt a felhasználók akadálytalanul hozzáférhetnek az eszközökhöz, és könnyen ellenőrizhetik azokat; másrészt a könnyen fertőtleníthető anyagok megakadályozzák a keresztszennyeződés kockázatát.",
        },
        {
          image: "/uploads/S200-bioster.png",
          alt: "S200 LCD Console",
          title: "BIOSTER",
          description:
            "Ez az intenzív fertőtlenítő rendszer automatikus fertőtlenítési ciklusokat futtat a permetezővíz-körökön, teljes védelmet nyújtva a mikroorganizmusok fogászati ​​egységen belüli átvitele ellen.",
        },
        {
          image: "/uploads/S200-iwfc.png",
          alt: "S200 LCD Console",
          title: "I.W.F.C.",
          description:
            "A BIOSTER rendszer részeként vagy külön megvásárolható eszköz biztosítja a vízkörök tisztítását, miután a gép egy bizonyos ideig tétlen volt.",
        },
        {
          image: "/uploads/S200-whe.png",
          alt: "S200 LCD Console",
          title: "W.H.E",
          description:
            "Ez egy folyamatos, Peroxy Ag+ (H2O2) alapú fertőtlenítő rendszer, amely egy légrés-eszközzel együtt működik, amely elválasztja a fő víz- és fogászati ​​kezelőegység áramköreit. Hatékony minden vízben terjedő szennyeződés, beleértve a Legionellát is, ellen.",
        },
        {
          image: "/uploads/S200-acvs.png",
          alt: "S200 LCD Console",
          title: "A.C.V.S",
          description:
            "Ez az automatikus rendszer szívórendszer-fertőtlenítési ciklusokat végez két beteg között.",
        },
        {
          image: "/uploads/S200-sanaspray.png",
          alt: "S200 LCD Console",
          title: "Sanapray",
          description:
            "Ez a desztilláltvíz-tartály, amelyet a vezetékes víz alternatívájaként kell használni.",
        }
      ],
    },
    {
      title: "Világítás",
      cards: [
        {
          image: "/uploads/S200-operacios.png",
          alt: "S200 Digit Console",
          title: "Operációs Lámpák",
          description:
            "Az S200-on elérhető kezelőlámpák széles választéka lehetővé teszi a szakemberek számára, hogy kiválasszák az igényeiknek leginkább megfelelő szintet.",
        },
        {
          image: "/uploads/S200-plus-sct.png",
          alt: "S200 LCD Console",
          title: "Venus Plus SCT",
          description:
            "Négy fényforrással felszerelt LED-es kezelőlámpa; magas színvisszaadási indexe valósághű, természetes színérzékelést biztosít. A fényerő 3000 és 50 000 lux között állítható, és a nagy spotvilágítási területnek köszönhetően optimalizálja a szájüreg megvilágítását zavaró árnyékok létrehozása nélkül.",
        },
        {
          image: "/uploads/S200-plus-sctc.png",
          alt: "S200 LCD Console",
          title: "Venus Plus SCT Kompozit",
          description:
            "4 fényforrással rendelkező LED-es lámpa, amelyek a reflektor testének külső részén helyezkednek el. Ezenkívül 2 központi fényforrás is található, amelyek különböző hullámhosszúságú nyalábot generálnak. Ezek megakadályozzák a kompozitok előpolimerizációját, miközben biztosítják a szájüreg kiváló megvilágítását.",
        },
        {
          image: "/uploads/S200-mct.png",
          alt: "S200 LCD Console",
          title: "Venus Led Mct",
          description:
            "Ez a verzió lehetővé teszi a színhőmérséklet (meleg, semleges és hideg) beállítását az anatómiai részletek pontosabb elemzése érdekében. A kompozit mód elkerüli a kompozitok előpolimerizációját, optimalizálva a helyreállítási eljárásokat.",
        },
        {
          image: "/uploads/S200-mct-view.png",
          alt: "S200 LCD Console",
          title: "Venus Led Mct View",
          description:
            "Ez a verzió egy 4K kamerát tartalmaz, amely segíti a betegekkel való kommunikációt és értékes klinikai dokumentációs eszközt biztosít. A folyékony lencsékkel ellátott Smart Focus rendszer pontos, automatikus fókuszálást biztosít manuális beállítások nélkül.",
        }
      ],
    }
  ],
};

export default S200;